import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation Logout {
    logout {
      success
    }
  }
`;

export const logout = async (authToken) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    options: { authToken },
  });
  return getSingleProp(result.data);
};
